// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import React from 'react'
import { node } from 'prop-types'
import { useSelector } from 'react-redux'
import WithMaintenanceWindow from './WithMaintenanceWindow'

const SystemMaintenanceCheck = ({ children }) => {
  // NOTE - we only want to show the maintenance window on PROD
  const profile = useSelector(state => state.applicationSettings.get('profile'))

  return (
    <div>
      {
        profile?.toLowerCase() === 'production'
          ? (
            <WithMaintenanceWindow>
              {children}
            </WithMaintenanceWindow>
          ) : children
      }
    </div>
  )
}

SystemMaintenanceCheck.propTypes = {
  children: node.isRequired,
}

export default SystemMaintenanceCheck
